import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import InlineSvg from "vue-inline-svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
  value: { type: Boolean, default: false },
  title: { type: String, default: "" },
  description: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  shouldHideCheckbox: { type: Boolean, default: false },
},
  emits: ["update:value", "onChangedCheck"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

// v-model 호환 computed
const checkedValue = computed({
  get: () => props.value,
  set(v: boolean) {
    emit("update:value", v);
  },
});

const onChangeChecked = (e: Event) => {
  emit("onChangedCheck", (e.target as HTMLInputElement).checked);
};

// description을 위한 고유 ID
const descId = `desc-${Math.random().toString(36).substr(2, 9)}`;

const __returned__ = { props, emit, checkedValue, onChangeChecked, descId, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})